export const getEntries: <TKey extends PropertyKey, TValue>(
  obj: MarkUndefinedFieldsAsOptional<Record<TKey, TValue>>
) => [TKey, TValue][] = Object.entries;

export const getKeys: <T>(obj: T) => (keyof T)[] = Object.keys;

export const fromEntries: <TKey extends PropertyKey, TValue>(
  entries: [TKey, TValue][]
) => Record<TKey, TValue> = Object.fromEntries;

type KeysWithUndefined<T> = {
  [K in keyof T]: undefined extends T[K] ? K : never;
}[keyof T];

type UndefinedOptionalPart<T> = {
  [K in KeysWithUndefined<T>]?: Exclude<T[K], undefined>;
};

type NonUndefinedPart<T> = {
  [K in Exclude<keyof T, KeysWithUndefined<T>>]: T[K];
};

type MarkUndefinedFieldsAsOptional<T> = UndefinedOptionalPart<T> &
  NonUndefinedPart<T>;
